import { render, staticRenderFns } from "./support-code.vue?vue&type=template&id=fd0b8a5a"
import script from "./support-code.vue?vue&type=script&lang=js"
export * from "./support-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports